import styles from './MadeIactivePro.module.css';
import iactiveLogo from '../../assets/images/iactive.png';

export const MadeIactivePro = ({ left = false }) => {
  return (
    <div className={styles.wrapper} style={{ left: left ? '3rem' : '' }}>
      <div>сделано на базе сервисов</div>
      <img src={iactiveLogo} alt="logoIactiveLogo" />
    </div>
  );
};
